document.addEventListener('DOMContentLoaded', function () {
  const testimonialsElement = document.querySelector('.testimonials-swiper');

  if (!testimonialsElement) {
    return;
  }

  new Swiper(testimonialsElement, {
    slidesPerView: 'auto',
    spaceBetween: 24,
    loop: true,
    autoHeight: false,
    watchOverflow: true,
    speed: 700,
    grabCursor: true,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: testimonialsElement.querySelector('.testimonials-pagination'),
      clickable: true,
    },
    keyboard: {
      enabled: true,
    },
    slideToClickedSlide: true,
  });
});
